import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { Col, Row, Stack } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { motion } from 'framer-motion'
import MainMenu from '../navigation/MainMenu'
import ProductMenu from '../navigation/ProductMenu'
import MegaMenu from '../navigation/MegaMenu'
import MobileMenu from '../navigation/MobileMenu'
import MobileMegaMenu from '../navigation/MegaMenu/MobileMegaMenu'
import HeaderCart from './HeaderCart'
import { productMenuItems, resourceMenuItems, communityMenuItems } from '../navigation/menuState'
import { AsyncWrapper } from '/src/components/common'
import { useUser } from '/src/hooks'

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

const UserAccountFormAsyncWrapper = () => {
  return (
    <AsyncWrapper>
      <HeaderMenuAccountDataWrapper />
    </AsyncWrapper>
  )
}

const HeaderMenuAccountDataWrapper = () => {
  const user = useUser()
  return <HeaderMenuAccount user={user} />
}

const HeaderMenuAccount = ({ user }) => {
  return (
    user ? (
      <Link className="login-link" to="/user" activeClassName="active">
        <FontAwesomeIcon icon={faUser} />My Account
        {user.trade && (
          <span>
            ({formatter.format(user.credit)})
          </span>
        )}
      </Link>
    ) : (
      <Link className="login-link" to="/user/login" activeClassName="active">
        <FontAwesomeIcon icon={faUser} />Login Or Sign Up
      </Link>
    )
  )
}

export default ({ mobileMenu }) => {
  return (
    <>
      <Row className="header-menu-row d-flex align-items-center">
        <Col xs={3} className="product-menu-col">
          <MegaMenu items={productMenuItems}>
            <ProductMenu />
          </MegaMenu>
        </Col>
        <Col xs={6}>
          <Stack direction="horizontal" gap="3">
            <MegaMenu items={communityMenuItems}>
              <MainMenu label="Community" route="/community" />
            </MegaMenu>
            <MegaMenu items={resourceMenuItems}>
              <MainMenu label="Resources" route="/resources" />
            </MegaMenu>
            <MainMenu label="Store Locator" route="/store-locator" noChildren />
          </Stack>
        </Col>
        <Col xs={3}>
          <UserAccountFormAsyncWrapper />
        </Col>
      </Row>
      <motion.div
        key="mobile-menu-motion"
        initial="exit"
        animate={mobileMenu ? "enter" : "exit"}
        variants={variantMenuAnimate}>
        <Row className="header-mobile-menu-row d-flex align-items-start">
          <Col xs={12} className="mobile-menu-col mt-2 mb-2">
            <MobileHeaderMenu />
          </Col>
        </Row>
      </motion.div>
    </>
  )
}

const MobileHeaderMenu = () => {
  const [display, setDisplay] = useState(false)

  const onClickHandler = (value) => {
    setDisplay(value)
  }

  return (
    <Stack direction="vertical" gap="3">
      <MobileProductMenu
        display={display} 
        onClickHandler={onClickHandler} />
      <MobileCommunityMenu 
        display={display} 
        onClickHandler={onClickHandler} />
      <MobileResourcesMenu 
        display={display} 
        onClickHandler={onClickHandler} />
      <MainMenu label="Store Locator" route="/store-locator" noChildren />
      <MobileCart />
      <HeaderMenuAccount />
    </Stack>
  )
}

const variantMenuAnimate = {
  enter: {
    opacity: 1,
    rotateX: 0,
    transition: {
      duration: 0,
      delay: 0
    },
    display: 'block'
  },
  exit: {
    opacity: 0,
    rotateX: -15,
    transition: {
      duration: 0,
      delay: 0
    },
    transitionEnd: {
      display: 'none'
    }
  }
}

//  <MobileResourcesMenu open={open} setOpen={setOpen} />
//  <MobileMegaMenu label="Store Locator" route="/store-locator" noChildren />

const MobileCart = () => {

  return (
    <div className="mobile-cart-container">
      <HeaderCart />
    </div>
  )
}

const MobileProductMenu = ({ display, onClickHandler }) => {
  const [open, setOpen] = useState(display)

  useEffect(() => {
    if (display !== '/products/all') {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }, [display])

  return (
    <MobileMegaMenu open={open} items={productMenuItems}>
      <MobileMenu 
        label="Products" 
        route="/products/all" 
        open={open} 
        onClickHandler={onClickHandler} />
    </MobileMegaMenu>
  )
}

const MobileCommunityMenu = ({ display, onClickHandler }) => {
  const [open, setOpen] = useState(display)

  useEffect(() => {
    if (display !== '/community') {
      setOpen(false)
    } else {
      setOpen(true) 
    }
  }, [display])

  return (
    <MobileMegaMenu open={open} items={communityMenuItems}>
      <MobileMenu 
        label="Community" 
        route="/community" 
        open={open} 
        onClickHandler={onClickHandler} />
    </MobileMegaMenu>
  )
}

const MobileResourcesMenu = ({ display, onClickHandler }) => {
  const [open, setOpen] = useState(display)

  useEffect(() => {
    if (display !== '/resources') {
      setOpen(false)
    } else {
      setOpen(true) 
    }
  }, [display])

  return (
    <MobileMegaMenu open={open} items={resourceMenuItems}>
      <MobileMenu 
        label="Resources" 
        route="/resources" 
        open={open} 
        onClickHandler={onClickHandler} />
    </MobileMegaMenu>
  )
}
